/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useState, useRef, useEffect} from "react";

import PropTypes from "prop-types";

import {indianCityList} from "nxtconstants";

import {
  useOnClickOutside
} from "helpers";

import SelectCity from "./SelectCity";

const propTypes = {
  alreadySelectedCity: PropTypes.string,
  cityList: PropTypes.array,
  onSelectedCityClick: PropTypes.func.isRequired,
  isMeetingForm: PropTypes.bool
};

const SelectCityContainer = ({
  alreadySelectedCity,
  onSelectedCityClick,
  cityList,
  isMeetingForm
}) => {
  const [showDatalist, setShowDatalist] = useState(false);
  const [searchedCity, setSearchedCity] = useState("");

  const datalistRef = useRef();

  useEffect(() => {
    if (alreadySelectedCity && alreadySelectedCity.length > 0) {
      setSearchedCity(alreadySelectedCity);
    }
  }, []);

  const activeCityList = cityList && cityList.length > 0 ? cityList : indianCityList;

  const filteredCities = activeCityList.filter((eachIndianCity) => eachIndianCity.toLowerCase().includes(searchedCity.toLowerCase()));

  useOnClickOutside(datalistRef, () => setShowDatalist(false));

  const onSearchCityClick = (city) => {
    setSearchedCity(city);
    setShowDatalist(false);
    onSelectedCityClick(city);
  };

  const onCityChangeHandler = (event) => {
    setSearchedCity(event.target.value);
  };

  return (
    <SelectCity
      datalistRef={datalistRef}
      filteredCities={filteredCities}
      searchedCity={searchedCity}
      setShowDatalist={setShowDatalist}
      showDatalist={showDatalist}
      onCityChangeHandler={onCityChangeHandler}
      onSearchCityClick={onSearchCityClick}
      isMeetingForm={isMeetingForm}
    />
  );
};

SelectCityContainer.propTypes = propTypes;

export default SelectCityContainer;
